import * as React from "react"; //test
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import axios from "axios";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import { useOtpSettings } from "./OtpContext";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import { Checkbox, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import TableSortLabel from "@mui/material/TableSortLabel";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import DownloadIcon from "@mui/icons-material/Download";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import "../App.css";
import { Modal } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getInstituteConfig } from "../utility/instituteConfig";

export default function AnnualSubscription({ props }) {
  let {
    studentId,
    refundBalance,
    setRefundBalance,
    studentName,
    academicYearId,
    gradeName,
    userId,
    gradeId,
    feesSlabId,
    pendingFees,
    sectionName,
    sectionId,
    userMail

  } = props;

  const [concession, setConcession] = useState(0);
  const [totalAmountPaid, setTotalAmountPaid] = useState(0);
  const [amountPending, setAmountPending] = useState(0);
  const [paymentMode, setPaymentMode] = useState([{}]);
  const [description, setDescription] = useState("");
  const [dateofbirthError, setDateofbirthError] = useState(false);
  const [paymentModeError, setPaymentModeError] = useState(false);
  const [paymentModeId, setPaymentModeId] = useState(null);
  const [includeRefundBalance, setIncludeRefundBalance] = useState(false);
  const [annualSubscriptionModal, setAnnualSubscriptionModal] = useState(false);
  const [amountPayableAfterConcession, setAmountPayableAfterConcession] =
    useState(0);
  const [addonTypeId, setaddonTypeId] = useState();
  const [annualSubscriptionPaymentId, setAnnualSubscriptionPaymentId] =
    useState(0);
  const [utrId, setUtrId] = useState("");
  const [addonType, setaddonType] = useState([]);
  const [paymentModeName, setPaymentModeName] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("annual_subscription_payment_id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [annualSubscription, setAnnualSubscription] = useState([{}]);
  const [addonTypeName, setAddonTypeName] = useState("");
  const [amountPayableError, setAmountPayableError] = useState(false);
  const [totalAmountPayable, setTotalAmountPayable] = useState(0);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [concessionError, setConcessionError] = useState("");
  const [totalAmountPaidError, setTotalAmountPaidError] = useState("");
  const [transactionIdError, setTransactionIdError] = useState("");
  const [addonTypeError, setAddonTypeError] = useState("");
  const [refundBalanceUsed, setRefundBalanceUsed] = useState(0);
  const [remainingRefundBalance, setRemainingRefundBalance] = useState("");
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [backendOtp, setBackendOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [verifyOTPMsg, setVerifyOTPMsg] = useState("");
  const [resendTimer, setResendTimer] = useState(600);
  const [canResend, setCanResend] = useState(true);
  const [resendCount, setResendCount] = useState(1); // Counter for resend attempts
  const [oldStudentConcession, setOldStudentConcession] = useState(0);
  const [oldTotalAmountPaid, setOldTotalAmountPaid] = useState(0);
  const [oldAmountPending, setOldAmountPending] = useState(0);
  const [oldPaymentMode, setOldPaymentMode] = useState([]);
  const [oldUtrId, setOldUrtId] = useState("");
  const [oldDescription, setOldDescription] = useState("");
  const [oldPaymentDate, setOldPaymentDate] = useState("");
  const [oldTotalAmountPayable, setOldAmountPayable] = useState(0);
  const [oldRefundUsed, setOldRefundUsed] = useState();
  const [staticPendingAmount, setStaticPendingAmount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

const instituteId = localStorage.getItem('instituteId');
// With this:
const instituteEmailMap = {
  "1": process.env.REACT_APP_EMAIL_JHS,
  "2": process.env.REACT_APP_EMAIL_JPS,
};
const [email, setEmail] = useState(instituteEmailMap[instituteId]);
  const navigate = useNavigate();
  const { isOtpEnabled } = useOtpSettings();


  useEffect(() => {
    const getFeesReport = async () => {
      fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/feesReport/getFeesReport",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials:'include',
          body: JSON.stringify({
            academic_year_id: academicYearId,
            grade_id: gradeId ? gradeId : null,
            fees_slab_id: feesSlabId ? feesSlabId : null,
            section_id: sectionId ? sectionId : null,
            pending_fees: pendingFees ? true : false,
            // Narrows the DB query to just this student instead of asking
            // for (and decrypting) the entire matching roster to find one
            // row.
            student_id: studentId,
          }),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          const targetStudentId = studentId; // Replace with the actual student ID you're checking for

          // getFeesReport now returns { rows, total } instead of a bare
          // array (added for pagination); unwrap .rows here.
          const rows = Array.isArray(response) ? response : response?.rows || [];

          // Find the student whose studentId matches the target
          const matchingStudent = rows.find(
            (student) => student.student_id === targetStudentId
          );

          if (matchingStudent) {
            const updatedRefund = matchingStudent.refund_amount;

            if (updatedRefund !== undefined) {
              setRefundBalance((prev) => {
                return updatedRefund;
              });
              console.log(
                "updatedRefund for Student:",
                updatedRefund,
                studentId
              );
            } else {
              console.error(
                "current_pending_amount not found for the matched student."
              );
            }
          } else {
            console.error("No student found with the specified studentId.");
          }
        });
    };
    getFeesReport();
  }, [academicYearId, gradeId, feesSlabId, pendingFees]);

  useEffect(() => {
    setOrder("desc");
    setOrderBy("annual_subscription_payment_id");
  }, []);

  //download reciept
  const handleDownload = (row, event) => {
    event.stopPropagation();
    const doc = new jsPDF();
    const institute = getInstituteConfig(instituteId);
    // Add Logo and Header
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    const textyy = 11;
    doc.setFont("helvetica", "bold");

    // School name
    doc.text(
      institute.name,  // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textyy,
      { align: "center" }
    );

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 8, 1, 28, 18);  // ✅ dynamic
    }

    // Address
    doc.setTextColor(0, 0, 0);
    const textStartY = 15;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1,  // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 10,
      { align: "center" }
    );
    doc.text(
      institute.address2,  // ✅ dynamic
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" }
    );
    if (institute.tel) {
      doc.text(
        institute.tel,  // ✅ dynamic, skipped for JPS
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 18,
        { align: "center" }
      );
    }

    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 30; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "ANNUAL SUBSCRIPTION RECEIPT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" }
    ); // Center aligned title
    doc.setFontSize(10);
    let studentDetailsY = receiptTextY + 10; // Adjust Y position after receipt info

    // Set font for student name and details
    doc.setFont("helvetica", "bold");
    const studentLabelX = 14;

  // Constants for padding and maximum widths
const PADDING = 5; // Uniform padding between elements
const MAX_NAME_WIDTH = 70; // Max width for student name before wrapping

// Handle long student name
const studentname = `${studentName || ""}`;
const studentNameWidth = doc.getTextWidth(studentname);
const splitStudentName =
  studentNameWidth > MAX_NAME_WIDTH
    ? doc.splitTextToSize(studentname, MAX_NAME_WIDTH)
    : studentname;

doc.text(`Name of Student: `, studentLabelX, studentDetailsY); // Left aligned
doc.setFont('helvetica', 'normal');
doc.text(splitStudentName, studentLabelX + 30, studentDetailsY); // Adjust X position for student name

// Dynamically calculate X position for Grade based on student name
const studentNameActualWidth = Math.min(studentNameWidth, MAX_NAME_WIDTH); // Use actual width or max width
const gradeX = studentLabelX + 30 + studentNameActualWidth + PADDING;

// Grade
doc.setFont('helvetica', 'bold');
doc.text(`Grade:`, gradeX, studentDetailsY);
const gradeLabelWidth = doc.getTextWidth(`Grade: `);
doc.setFont('helvetica', 'normal');
const gradeValue = `${gradeName || ''}`;
doc.text(gradeValue, gradeX + gradeLabelWidth, studentDetailsY);

// Dynamically calculate X position for Section based on Grade
const gradeValueWidth = doc.getTextWidth(gradeValue);
const sectionX = gradeX + gradeLabelWidth + gradeValueWidth + PADDING;

// Section
doc.setFont('helvetica', 'bold');
doc.text(`Section:`, sectionX, studentDetailsY);
const sectionLabelWidth = doc.getTextWidth(`Section: `);
doc.setFont('helvetica', 'normal');
const sectionValue = `${sectionName || ''}`;
const sectionValueWidth = doc.getTextWidth(sectionValue);

// Check if Section exceeds page width and adjust
if (sectionX + sectionLabelWidth + sectionValueWidth > doc.internal.pageSize.width) {
  // Move to the next line if it exceeds the page width
  studentDetailsY += 10; // Adjust Y position
  doc.text(`Section:`, studentLabelX, studentDetailsY); // Start from the left
  doc.text(sectionValue, studentLabelX + sectionLabelWidth, studentDetailsY);
} else {
  // Place Section normally
  doc.text(sectionValue, sectionX + sectionLabelWidth, studentDetailsY);
}

    // Table for Particulars (example data)
    const receiptDetails = [
      {title: "Annual Subscription Payment ID",value: row.annual_subscription_payment_id,},
      { title: "Addon Type", value: row.addon_type_name },
      { title: "Amount Paid", value: row.amount_paid },
      { title: "Amount Pending", value: row.amount_pending },
      { title: "Payment Date", value: row.payment_date },
      { title: "Payment Mode", value: row.payment_mode_name },
      { title: "Transaction ID", value: row.transaction_id || "N/A" },
      { title: "Refund Amount Used", value: row.refund_amount_used },
      { title: "Description", value: row.description },
    ];

    // Table settings
doc.autoTable({
  head: [["Particulars", "Amount"]],
  body: receiptDetails.map((item) => [item.title, item.value]),
  startY: receiptTextY + 13, // Start table below student details
  styles: { fontSize: 10, cellPadding: 2 }, // Adjust padding for consistency
  headStyles: {
    fillColor: "#0A64A2", // Blue header
    textColor: [255, 255, 255], // White text
    halign: "left", // Center-align header text
  },
  bodyStyles: {
    halign: "left", // Align text to the left in the body
  },
  columnStyles: {
    0: { cellWidth: 90, halign: "left" }, // Fixed width for the "Particulars" column
    1: { cellWidth: 90, halign: "left" }, // Fixed width for the "Amount" column
  },
  theme: "grid",
});


    const currentDate = new Date();

    // Format the date as DD/MM/YYYY
    const formattedDate = `${String(currentDate.getDate()).padStart(
      2,
      "0"
    )}/${String(currentDate.getMonth() + 1).padStart(
      2,
      "0"
    )}/${currentDate.getFullYear()}`;

    // Add the text with the current date
    doc.setFont("helvetica", "bold");
    doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 40);
    doc.setFont("helvetica", "bold");
    doc.text("Authorized Signatory", 158, doc.previousAutoTable.finalY + 40); // Right aligned for signature

    // Save the PDF
    doc.save(
      `annual-subscription-payment-receipt_${new Date()
        .toISOString()
        .slice(0, 10)}.pdf`
    );
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Ensure 2-digit month
    const day = String(today.getDate()).padStart(2, "0"); // Ensure 2-digit day
    return `${year}-${month}-${day}`;
  };
  const [paymentDate, setPaymentDate] = useState(getTodayDate);

  const handleChange = (event) => {
    const selectedAddontype = addonType.find(
      (pm) => pm.addon_type_name === event.target.value
    );
    if (selectedAddontype) {
      setAddonTypeName(event.target.value);
      setaddonTypeId(selectedAddontype.addon_type_id);
      console.log("Selected Addon Type ID:", selectedAddontype.addon_type_id);
    } else {
      console.error("Addon type not found for:", event.target.value);
    }
    setAddonTypeError("");
  };

  const handleChangePayment = (event) => {
    const selectedMode = event.target.value;
    setPaymentModeName(selectedMode);
    let selectedPaymentMode = paymentMode.find(
      (pm) => pm.payment_mode_name === event.target.value
    );
    setPaymentModeId(selectedPaymentMode.payment_mode_id);
    setPaymentModeError("");
    if (selectedMode === "Cash" || selectedMode === "Using Refund Balance") {
      setUtrId(""); // Clear the transaction ID when payment mode is Cash
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Sorting comparator
  const comparator = (a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    }
    return a[orderBy] > b[orderBy] ? -1 : 1;
  };

  // Apply sorting
  const sortedRows = [...annualSubscription].sort(comparator);

  // Apply pagination
  const paginatedRows = sortedRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  useEffect(() => {
    const slab = parseFloat(totalAmountPayable) || 0;
    const concessionAmount = parseFloat(concession) || 0;
    const refund = includeRefundBalance ? parseFloat(refundBalanceUsed) || 0 : 0; // Subtract refund balance only if included
  
    const newAmountPayable = Math.max(0, slab - concessionAmount - refund); // Ensure non-negative value
  
    setAmountPayableAfterConcession(newAmountPayable);
  }, [totalAmountPayable, concession, amountPending, includeRefundBalance, refundBalanceUsed]);
  

  useEffect(() => {
    const payableAfterConcession =
      parseFloat(amountPayableAfterConcession) || 0;
    const paidAmount = parseFloat(totalAmountPaid) || 0;

    const newAmountPending = Math.max(0, payableAfterConcession - paidAmount); // Ensure non-negative value

    setAmountPending(newAmountPending);
  }, [amountPayableAfterConcession, totalAmountPaid]);

  useEffect(() => {
    // Parse all necessary values, fallback to 0 if any are invalid
    let slab = parseFloat(totalAmountPayable) || 0; // Total amount payable
    let concessionAmount = parseFloat(concession) || 0; // Concession provided
    let refundBalanceAmount = parseFloat(refundBalance) || 0; // Initial refund balance
    let amountPaid = parseFloat(totalAmountPaid) || 0; // Amount that has been paid

    // Calculate the amount payable after concession
    let payableAfterConcession = slab - concessionAmount;
    payableAfterConcession = Math.max(payableAfterConcession, 0); // Ensure it is not negative

    // Calculate the amount pending as the amount after concession minus the amount paid
    let amountPending = payableAfterConcession - amountPaid;

    // Initialize refund balance usage
    let refundBalanceUsed = 0;
    let remainingRefundBalance = refundBalanceAmount;

    // Check if the refund balance should be included
    if (includeRefundBalance) {
      amountPending = Math.max(amountPending, 0);
      // Apply only the portion of the refund balance that is less than or equal to the amountPending
      refundBalanceUsed = Math.min(remainingRefundBalance, amountPending); // Refund usage is limited to the lesser of the two

      // Update the amount pending by reducing it by the refund balance used
      amountPending -= refundBalanceUsed;

      // Update the remaining refund balance
      remainingRefundBalance -= refundBalanceUsed;

      if (staticPendingAmount === null) {
        setStaticPendingAmount(amountPending);
      }
    }

    // Ensure that the amountPending and remainingRefundBalance are not negative
    amountPending = Math.max(amountPending, 0);
    remainingRefundBalance = Math.max(remainingRefundBalance, 0);

    // Update the state with the calculated values
    setAmountPayableAfterConcession(payableAfterConcession);
    setAmountPending(amountPending);
    // setTotalAmountPaid(amountPaid);
    setRemainingRefundBalance(remainingRefundBalance);
    setRefundBalanceUsed(refundBalanceUsed);
  }, [
    totalAmountPayable,
    concession,
    refundBalance,
    includeRefundBalance,
    // totalAmountPaid,
  ]);

  const handleTransactionIdPopup = () => {
    setAnnualSubscriptionModal(false);
  };

  const fetchAddonTypes = async () => {
    fetch(
      process.env.REACT_APP_JHS_DEVELOPMENT + "/annualSubscription/addonType",
      {
        method: "GET",
        headers: { "Content-type": "application/json" },
        
      }
    )
      .then((response) => response.json())
      .then((response) => {
        setaddonType(response);
      });
  };

  useEffect(() => {
    fetchAddonTypes();
  }, []);

  const handleSelectRow = (
    annualSubscriptionPaymentId,
    addonTypeName,
    totalAmountPayable,
    concession,
    totalAmountPaid,
    amountPending,
    paymentDate,
    paymentModeName,
    refundBalance,
    refundBalanceUsed,
    transactionId,
    description,
    paymentModeId
  ) => {
    setAnnualSubscriptionPaymentId(annualSubscriptionPaymentId);
    setAddonTypeName(addonTypeName);
    setTotalAmountPayable(totalAmountPayable);

    // Check if this logs the correct value
    setConcession(concession);
    setRefundBalance(refundBalance);
    setPaymentModeId(paymentModeId);

    // Only calculate amountPayableAfterConcession if it hasn't been set yet or is 0
    if (!amountPayableAfterConcession || amountPayableAfterConcession === 0) {
      let calculatedAmountPayableAfterConcession =
        totalAmountPayable - concession;
      calculatedAmountPayableAfterConcession -= refundBalance; // Adjust based on refund balance
      setAmountPayableAfterConcession(calculatedAmountPayableAfterConcession);
    }

    setTotalAmountPaid(totalAmountPaid + refundBalanceUsed);
    setPaymentModeName(paymentModeName);

    // Convert the paymentDate to YYYY-MM-DD format
    const formattedDate = new Date(paymentDate).toISOString().split("T")[0];
    setPaymentDate(formattedDate); // Set the formatted date

    setUtrId(transactionId);
    setOldRefundUsed(refundBalanceUsed);
    setDescription(description);

    // Clear any previous errors
    setAddonTypeError("");
    setAmountPayableError("");
    setTotalAmountPaidError("");
    setPaymentModeError("");
    setOldAmountPending(amountPending);
    setOldStudentConcession(concession);
    setOldTotalAmountPaid(totalAmountPaid);
    setOldPaymentDate(paymentDate);
    setOldPaymentMode(paymentModeName);
    setOldUrtId(transactionId);
    setOldDescription(description);
    setOldAmountPayable(totalAmountPayable);
  };

  const addPaymentDetails = (e) => {
    let totalAmountPaidError = "";
    let dateofbirthError = "";
    let paymentModeError = "";
    let amountPayableError = "";
    let transactionIdError = "";
    let addonTypeError = "";

    if (!totalAmountPayable || parseFloat(totalAmountPayable) === 0) {
      amountPayableError = "Amount Payable is required";
    } else if (!totalAmountPayable || parseFloat(totalAmountPayable) < 0) {
      amountPayableError = "Amount Payable is can't negative";
    }

    // Validate Addon Type
    if (!addonTypeId || addonTypeId === "" || parseFloat(addonTypeId) === 0) {
      addonTypeError = "Addon Type is required";
    }

    // Validate amount paid

    if (!includeRefundBalance) {
      if ((!totalAmountPaid || totalAmountPaid === "" || isNaN(parseFloat(totalAmountPaid))) && amountPending !== 0) {
        totalAmountPaidError = "Amount Paid is required";
      } else if (parseFloat(totalAmountPaid) < 0) {
        totalAmountPaidError = "Amount Paid can't negative";
      }  else if (
        amountPayableAfterConcession &&
        parseFloat(totalAmountPaid) > amountPayableAfterConcession
      ) {
        totalAmountPaidError =
          "Amount can't exceed amount after concession";
      } else if (
        !concession &&
        parseFloat(totalAmountPaid) > parseFloat(addonType)
      ) {
        totalAmountPaidError =
          "Amount can't exceed annual subscription payment";
      }
    }
    else if(includeRefundBalance){
      if ((!totalAmountPaid || totalAmountPaid === "" || isNaN(parseFloat(totalAmountPaid))) && amountPending !== 0) {
        totalAmountPaidError = "Amount Paid is required";
      }
    
    }

    if (
      (paymentModeName === "UPI" || paymentModeName === "DD/Cheque") &&
      (!utrId || utrId.trim() === "")
    ) {
      transactionIdError =
        paymentModeName === "DD/Cheque"
          ? "DD/Cheque number is required."
          : "Transaction ID is required.";
    }

    // Validate payment date
    if (!paymentDate) {
      dateofbirthError = "Payment date is required";
    }

    // Validate payment mode
    if (
      !paymentModeId ||
      paymentModeId === "" ||
      parseFloat(paymentModeId) === 0
    ) {
      paymentModeError = "Payment Mode is required";
    }

    if (includeRefundBalance) {
      if (parseFloat(totalAmountPaid) > parseFloat(staticPendingAmount) && parseFloat(amountPending) === 0 &&
       parseFloat(staticPendingAmount) !== 0) {
        totalAmountPaidError = "Amount can't exceed amount pending.";
      }
    }

    // Set errors and stop form submission if there are any errors
    if (
      totalAmountPaidError ||
      dateofbirthError ||
      paymentModeError ||
      amountPayableError ||
      transactionIdError ||
      addonTypeError
    ) {
      setTotalAmountPaidError(totalAmountPaidError);
      setDateofbirthError(dateofbirthError);
      setPaymentModeError(paymentModeError);
      setAmountPayableError(amountPayableError);
      setTransactionIdError(transactionIdError);
      setAddonTypeError(addonTypeError);
      return;
    }

    // Clear errors if no issues

    setTotalAmountPaidError("");
    setConcessionError("");
    setDateofbirthError("");
    setPaymentModeError("");
    setAmountPayableError("");
    setTransactionIdError("");
    setAddonTypeError("");
     setIsLoading(true); // Start loading
    fetch(
      process.env.REACT_APP_JHS_DEVELOPMENT + "/annualSubscription/saveAnnualSubscription",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          annual_subscription_payment_id: annualSubscriptionPaymentId,
          student_id: studentId,
          addon_type_id: addonTypeId,
          amount_payable: totalAmountPayable,
          concession: isNaN(concession) ? "0.00" : concession,
          amount_paid: isNaN(totalAmountPaid) ? "0.00" : totalAmountPaid,
          amount_pending: amountPending,
          payment_mode_id: paymentModeId,
          transaction_id: utrId,
          payment_date: paymentDate,
          refund_amount: refundBalance,
          academic_year_id: academicYearId,
          description: description,
          refund_amount_used: refundBalanceUsed,
          remaining_refund_balance: remainingRefundBalance,
          created_by: userId,
        }),
      }
    )
      .then((response) => {
        if (response.status === 401) {
          console.warn("Unauthorized access. Redirecting to Sign In...");
          navigate("/signin"); // Redirect to sign-in page
          return; // Stop further execution
        }
    
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        return response.json();
      })
      .then((data) => {
        handleResponse(data);
      })
      .catch((error) => {
        console.error("Error submitting payment details:", error);
        // Open Snackbar for error
      })
       .finally(() => {
      setIsLoading(false); // Stop loading
    });
    
  };

  const editPaymentDetails = () => {
    // Proceed with form submission
    fetch(
      `${process.env.REACT_APP_JHS_DEVELOPMENT}/annualSubscription/editAnnualSubscription`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          annual_subscription_payment_id: annualSubscriptionPaymentId,
          student_id: studentId,
          addon_type_id: addonTypeId,
          payment_mode_id: paymentModeId,
          transaction_id: utrId,
          payment_date: paymentDate,
          academic_year_id: academicYearId,
          description: description,
          updated_timestamp: new Date(),
          updated_by: userId,
        }),
      }
    )
      .then((response) => {
    
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
    
        return response.json();
      })
      .then((data) => {
        // Handle the response directly here
        console.log("Server Response:", data);

        handleResponse(data);
        
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  };

  const handleResponse = (responseObject) => {
    if (responseObject.status === 200) {
      getAnnualSubscription();
      setAnnualSubscriptionModal(false);
      const message = annualSubscriptionPaymentId ? "Payment updated successfully" : "Payment added successfully";
      setSnackbarMessage(message);
      setSnackbarMessageColor("success");
      setShowSnackbarMessage(true);
      handleResetForm();
    }
    if (responseObject.status === 400) {
      setSnackbarMessage(responseObject.error);
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
    }
  };
  const handleResetForm = () => {
    setAnnualSubscriptionPaymentId("");
    setAddonTypeName("");
    setTotalAmountPayable("");
    setConcession("");
    setAmountPayableAfterConcession("");
    setTotalAmountPaid("");
    setAmountPending("");
    setPaymentModeName("");
    setPaymentModeId(null);
    setPaymentDate(getTodayDate);
    setUtrId("");
    setDescription("");
    
    // Reset OTP-related states
    setIsOtpModalOpen(false);
    setOtp(["", "", "", "", "", ""]);
    setVerifyOTPMsg("");
    setBackendOtp("");
    setOtpSent(false);
    setResendTimer(600);
    setCanResend(true);
    setResendCount(1);

    setTimeout(() => {
      setRefundBalance(remainingRefundBalance);
    }, 2000);
  };

  const reset = () => {
    setAnnualSubscriptionPaymentId("");
    setAddonTypeName("");
    setTotalAmountPayable("");
    setConcession("");
    setAmountPayableAfterConcession("");
    setTotalAmountPaid("");
    setAmountPending("");
    setPaymentModeName("");
    setPaymentModeId(null)
    setPaymentDate(getTodayDate);
    setUtrId("");
    setDescription("");
  };

  const handleConcessionChange = (event) => {
    const value = event.target.value;
    let numericValue = parseFloat(value);

    let error = ""; // Use a string for a single error message
     
    const paidAmount = parseFloat(totalAmountPaid) || 0;

    const payableAmount = parseFloat(totalAmountPayable) || 0;

    const refuundAmount = parseFloat(refundBalanceUsed) || 0;
    

    
    // Perform validation
 
    if (numericValue > (payableAmount - paidAmount)) {
      error = "Concession can't exceed amount pending.";
      numericValue = Number(value.slice(0, String(payableAmount - paidAmount).length)); // Truncate the value
    } if (includeRefundBalance && numericValue > (payableAmount - refuundAmount)) {
      error = "Concession can't exceed amount pending.";
      numericValue = Number(value.slice(0, String(payableAmount - refuundAmount).length)); // Truncate the value
    } else if (includeRefundBalance && paidAmount > 0 && numericValue > (payableAmount - paidAmount - refuundAmount)) {
      error = "Concession can't exceed amount pending.";
      numericValue = Number(value.slice(0, String(payableAmount - paidAmount - refuundAmount).length)); // Truncate the value
    } 
    else if (numericValue < 0) {
      error = "Concession should not be negative.";
      numericValue = Number(value.slice(0, String(payableAmount - paidAmount).length)); // Truncate the value
    } else {
      delete error.concession;
    }

    // Update state
    setConcession(numericValue); // Set the updated value
    setConcessionError(error); // Set the error message
  };

  const handleAmountPaidChange = (event) => {
    const value = event.target.value;
    let numericValue = parseFloat(value); // Use `let` for reassignment

    let error = ""; // Use a string for a single error message

    // Perform validation
    if (
      !amountPayableAfterConcession &&
      parseFloat(value) > totalAmountPayable
    ) {
      error = "Amount can't exceed amount payable.";
      numericValue = Number(value.slice(0, String(totalAmountPayable).length)); // Truncate the value
    } else if (
      amountPayableAfterConcession &&
      parseFloat(value) > amountPayableAfterConcession
    ) {
      error = "Amount can't exceed amount after concession.";
      numericValue = Number(
        value.slice(0, String(amountPayableAfterConcession).length)
      ); // Truncate the value
    } else {
      delete error.totalAmountPaid;
    }

    if(includeRefundBalance){
      if (
        staticPendingAmount &&
        parseFloat(value) > staticPendingAmount
      ) {
        error = " Amount can't exceed amount pending.";
        numericValue = Number(
          value.slice(0, String(staticPendingAmount).length)
        ); // Truncate the value
      }
    
    }

    // Update state
    setTotalAmountPaid(numericValue); // Set the updated value
    setTotalAmountPaidError(error); // Set the error message
  };

  useEffect(() => {
    getAnnualSubscription();
  }, [academicYearId, studentId]);

  const getAnnualSubscription = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT +
          "/annualSubscription/getAnnualSubscription",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials:'include',
          body: JSON.stringify({
            academic_year_id: academicYearId,
            student_id: studentId,
          }),
        }
      );

    
       // If the response status is 401, call signOut
    if (response.status === 401) {
      console.warn("Unauthorized access. Redirecting to Sign In...");
      navigate("/signin"); // Redirect to sign-in page
      return; // Stop further execution
    }

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }


      const data = await response.json();
      console.log("Frontend Data:", data);

      // Extract the array from the response object
      if (data && data.fn_get_annual_subscription_payments_by_student_id_academic_year) {
        setAnnualSubscription(
          data.fn_get_annual_subscription_payments_by_student_id_academic_year
        );
      } else {
        console.error(
          "Expected array under key 'fn_get_annual_subscription_payments_by_student_id_academic_year' but got:",
          data
        );
        setAnnualSubscription([]); // Set empty array if data is not as expected
      }
    } catch (error) {
      console.error("Error fetching annual subscription details:", error);
    }
  };

  const handleCheckboxChange = (event) => {
    setIncludeRefundBalance(event.target.checked);

    // Update the updated refund balance based on the checkbox state
    if (event.target.checked) {
      setRefundBalance(refundBalance); // If fully included, set to 0
    }
  };

  const getPaymentMode = async () => {
    fetch(
      process.env.REACT_APP_JHS_DEVELOPMENT + "/paymentMode/getPaymentMode",
      {
        method: "GET",
        headers: { "Content-type": "application/json" },
        credentials:'include',
      }
    )
      .then((response) => response.json())
      .then((response) => {
        setPaymentMode(response);
      });
  };

  useEffect(() => {
    getPaymentMode();
  }, []);
  const handleGetOtp = async () => {
    const otpRequiredForAnnualSubscription = isOtpEnabled('AnnualSubscription');
    console.log('OTP required for AnnualSubscription:', otpRequiredForAnnualSubscription);
    if (!otpRequiredForAnnualSubscription) {
      if (annualSubscriptionPaymentId) {
          // ✅ Check for changes before saving
      const hasChanges =
        oldPaymentMode !== paymentModeName ||
        oldUtrId !== utrId ||
        oldPaymentDate !== paymentDate ||
        oldDescription !== description;

      if (!hasChanges) {
        setSnackbarMessage("No changes detected.");
        setSnackbarMessageColor("error");
        setShowSnackbarMessage(true);
        return;
      }

        editPaymentDetails();
      } else {
        addPaymentDetails();
      }
      return;
    }
    setSnackbarMessage("OTP sent successfully.");
    setSnackbarMessageColor("success");
    setShowSnackbarMessage(true);
    try {
      const paymentDetails = {
        payment_mode_name: paymentModeName,
        transaction_id: utrId,
        payment_date: paymentDate,
        description: description,
      };
      const paymentType = "Annual Subscription Payment";
      const paymentId = annualSubscriptionPaymentId;

      // Assuming you have a way to get the oldPaymentDetails
      const oldPaymentDetails = {
        payment_mode_name: oldPaymentMode,
        transaction_id: oldUtrId,
        payment_date: oldPaymentDate,
        description: oldDescription,
      };

      setEmail(process.env.REACT_APP_EMAIL);
      const response = await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/send-otp/getOtp", 
        {
          email,
          userMail,
          paymentId,
          updatedPaymentDetails: paymentDetails,
          oldPaymentDetails: oldPaymentDetails, // Include old details here
          userId: userId,
          paymentType,
          studentName,
          gradeName,
          sectionName,
          created_by: userId,
        },
        {withCredentials:'true'}
      );

      console.log(response.data.message);
      if (response.data.otp) {
        setBackendOtp(response.data.otp);
        setOtpSent(true);
        setResendTimer(600);
        setCanResend(false);
        setOtp(["", "", "", "", "", ""]);
        console.log("otp", paymentDetails);
        setIsOtpModalOpen(true); // Open OTP modal
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setSnackbarMessage("No changes detected.");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      if (error.status === 401) {
        console.warn("Unauthorized access. Redirecting to Sign In...");
        navigate("/signin"); // ✅ Fix: Ensure correct spelling
        return;
      }
      // setTimeout(() => {
      //   reset();
      // }, 2000);
    }
  };

  const handleVerifyOtp = (event) => {
    event.preventDefault();
    const enteredOtp = otp.join(""); // Combine the entered OTP from the input boxes

    // Check if the OTP field is empty
    if (!enteredOtp) {
      setVerifyOTPMsg("Please enter the OTP");
      return;
    }

    // Check if the entered OTP matches the backend OTP
    if (enteredOtp === backendOtp) {
      setVerifyOTPMsg("OTP Verified Successfully");
      // addPaymentDetails();
      editPaymentDetails();
      setIsOtpModalOpen(false); // Close the modal on successful verification
      setOtp(["", "", "", "", "", ""]);
      setVerifyOTPMsg(""); // Clear any verification message
      setResendCount(0); // Reset resend count
      setResendTimer(600); // Reset resend timer
      setCanResend(true); // Disable resend button
    } else {
      setVerifyOTPMsg("Invalid OTP"); // Show this if the OTP is incorrect
    }
  };

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Focus on the next input
      if (value !== "" && index < otp.length - 1) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
      // Focus on the previous input
      if (value === "" && index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  // Add this useEffect to handle the countdown timer
useEffect(() => {
  let intervalId;
  
  if (isOtpModalOpen && resendTimer > 0 && !canResend) {
    intervalId = setInterval(() => {
      setResendTimer((prevTimer) => {
        if (prevTimer <= 1) {
          setCanResend(true);
          clearInterval(intervalId);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
  }

  return () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  };
}, [isOtpModalOpen, canResend, resendTimer]);
 

  // Format time to MM:SS
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

const handleResendOtp = () => {
  if (canResend && resendCount < 3) {
    setResendCount(prev => prev + 1);
    handleGetOtp(); // Triggers OTP generation and email
    setCanResend(false); // Disable until timer ends
    setResendTimer(600);  // Restart the timer
  } else {
    setVerifyOTPMsg("You have reached the maximum number of resend attempts.");
  }
};


  const handleCloseModal = () => {
    setIsOtpModalOpen(false);

    // Reset all states related to OTP input, verification, and timers
    setOtp(["", "", "", "", "", ""]); // Reset OTP fields
    setVerifyOTPMsg(""); // Clear any verification message
    setResendCount(0); // Reset resend count
    setResendTimer(600); // Reset resend timer
    setCanResend(true); // Disable resend button
    setAnnualSubscriptionPaymentId("");
    handleResetForm();
  };

  return (
    <div>
      <div className="main_title">Annual Subscription</div>
      <br />

      <Dialog onClose={handleTransactionIdPopup} open={annualSubscriptionModal}>
        <DialogTitle
          alignSelf={"left"}
          style={{
            paddingBottom: "0",
            marginLeft: "9px",
            marginRight: "6px",
            color: "#0A64A2",
          }}
        >
          {
            annualSubscriptionPaymentId
              ? paymentModeName === "DD/Cheque"
                ? "Edit DD/Cheque No"
                : "Edit Transaction ID" // If feePaymentId exists
              : paymentModeName === "DD/Cheque"
              ? "Add DD/Cheque No"
              : "Add Transaction ID" // If feePaymentId does not exist
          }
          <Divider className="divider" />
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleTransactionIdPopup}
          size="small"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Stack spacing={4} padding={1}>
            <TextField
              id="outlined-basic"
              value={utrId}
              onChange={(event) => {
                setUtrId(event.target.value);
                setTransactionIdError("");
              }}
              size="small"
              error={!!transactionIdError}
              label={
                transactionIdError
                  ? transactionIdError // Show error as label if present
                  : paymentModeName === "DD/Cheque"
                  ? "Enter DD/Cheque No" // Change label based on payment mode
                  : "Enter Transaction ID"
              }
              variant="outlined"
              inputProps={{ maxLength: 20 }}
            />
            <div className="button-container">
              <Button
                className="save_update_btn"
                variant="contained"
                onClick={() => {
                  setAnnualSubscriptionModal(false);
                  let transactionIdError = "";
                  if (
                    (paymentModeName === "UPI" ||
                      paymentModeName === "DD/Cheque") &&
                    (!utrId || utrId.trim() === "")
                  ) {
                    transactionIdError =
                      paymentModeName === "DD/Cheque"
                        ? "DD/Cheque number is required."
                        : "Transaction ID is required.";
                  }

                  if (transactionIdError) {
                    setAnnualSubscriptionModal(true);
                    setTransactionIdError(transactionIdError);
                    return;
                  }

                  setTransactionIdError("");
                }}
              >
                {annualSubscriptionPaymentId ? <>Update</> : <>Save</>}
              </Button>
            </div>
          </Stack>
        </DialogContent>
      </Dialog>

      <Stack spacing={8} direction="row">
        <Stack spacing={1} direction="column">
          <TextField
            required
            className="text-field"
            size="small"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label={addonTypeError ? addonTypeError : "Select Add-on Type"}
            value={addonTypeName}
            name="addonTypeName"
            select
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            error={!!addonTypeError}
            disabled={annualSubscriptionPaymentId}
          >
            {Array.isArray(addonType) &&
              addonType.map((pm) => {
                return (
                  <MenuItem key={pm.addon_type_id} value={pm.addon_type_name}>
                    {pm.addon_type_name}
                  </MenuItem>
                );
              })}
          </TextField>

          <TextField
            required
            error={!!amountPayableError}
            id="outlined-basic"
            value={totalAmountPayable}
            onChange={(event) => {
              console.log("New Total Amount Payable:", event.target.value);
              setTotalAmountPayable(event.target.value);
              setAmountPayableError("");
            }}
            size="small"
            label={
              amountPayableError ? amountPayableError : "Total Amount Payable"
            }
            variant="outlined"
            type="number"
            inputProps={{ maxLength: 10 }}
            InputLabelProps={{ shrink: true }}
            onFocus={() => {
              // Clear the field when it's focused and the initial value is 0
              if (totalAmountPayable === 0) {
                setTotalAmountPayable("");
              }
            }}
            disabled={annualSubscriptionPaymentId}
          />

          <TextField
            disabled={((concession === amountPending || concession === "")  && amountPending === 0) || annualSubscriptionPaymentId }
            id="outlined-basic"
            type="number"
            name="concession"
            value={concession}
            onChange={(event) => {
              handleConcessionChange(event);
            }}
            label={concessionError ? concessionError : " Concession"}
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
            error={!!concessionError}
            onFocus={() => {
              // Clear the field when it's focused and the initial value is 0
              if (concession === 0) {
                setConcession("");
              }
            }}
           
          />
        </Stack>
        <Stack spacing={1} direction="column">
          <TextField
            id="outlined-basic"
            disabled
            value={amountPayableAfterConcession}
            onChange={(event) => {
              setAmountPayableAfterConcession(event.target.value);
            }}
            size="small"
            label="Amount after Concession"
            variant="outlined"
            type="number"
            InputLabelProps={{ shrink: true }}
            className="text-field"
          />

          <TextField
            id="outlined-basic"
            error={!!totalAmountPaidError}
            type="number"
            value={totalAmountPaid}
            size="small"
            onChange={(event) => {
              handleAmountPaidChange(event);
            }}
            label={
              totalAmountPaidError ? totalAmountPaidError : "Total Amount Paid"
            }
            required
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            onFocus={() => {
              // Clear the field when it's focused and the initial value is 0
              if (totalAmountPaid === 0) {
                setTotalAmountPaid("");
              }
            }}
            className="text-field"
            disabled={((totalAmountPaid === amountPending || totalAmountPaid === "" || isNaN(totalAmountPaid))  && amountPending === 0) || annualSubscriptionPaymentId }
          />

          <TextField
            id="outlined-basic"
            value={amountPending}
            onChange={(event) => {
              setAmountPending(event.target.value);
            }}
            size="small"
            label="Amount Pending"
            variant="outlined"
            type="number"
            disabled
          />
        </Stack>

        <Stack spacing={1} direction="column">
          <Box sx={{ minWidth: 260 }}>
            <TextField
              id="outlined-basic"
              required
              type="date"
              defaultValue={null}
              value={paymentDate}
              onChange={(event) => {
                setPaymentDate(event.target.value);
                setDateofbirthError("");
              }}
              size="small"
              variant="outlined"
              label={dateofbirthError ? dateofbirthError : "Payment Date"}
              error={!!dateofbirthError}
              InputLabelProps={{ shrink: true }}
              sx={{
                '& input[type="date"]::-webkit-calendar-picker-indicator': {
                  cursor: "pointer", // Change cursor to pointer for the calendar icon
                },
              }}
              className="text-field"
            />
          </Box>

          <Box sx={{ minWidth: 250 }}>
            <TextField
              className="text-field"
              size="small"
              label={
                paymentModeError ? paymentModeError : "Select Payment Mode"
              }
              error={!!paymentModeError}
              required
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={paymentModeName}
              name="paymentModeName"
              select
              onChange={handleChangePayment}
              InputLabelProps={{ shrink: true }}
            >
              {paymentMode.map((pm) => {
                return (
                  <MenuItem
                    key={pm.payment_mode_id}
                    value={pm.payment_mode_name}
                  >
                    {pm.payment_mode_name}
                  </MenuItem>
                );
              })}
            </TextField>
          </Box>
          <TextField
            id="outlined-basic"
            value={utrId}
            onClick={() => {
              if (
                !paymentModeName ||
                paymentModeName === "Cash" ||
                paymentModeName === "Using Refund Balance"
              ) {
                setAnnualSubscriptionModal(false);
              } else {
                setAnnualSubscriptionModal(true);
              }
            }}
            onChange={(event) => {
              setUtrId(event.target.value);
            }}
            size="small"
            label={
              transactionIdError
                ? transactionIdError // Show error as label if present
                : paymentModeName === "DD/Cheque"
                ? "Enter DD/Cheque No" // Change label based on payment mode
                : "Enter Transaction ID"
            } // Default label
            disabled={
              !paymentModeName ||
              paymentModeName === "Cash" ||
              paymentModeName === "Using Refund Balance"
            }
            variant="outlined"
            inputProps={{ maxLength: 20 }}
            InputLabelProps={{ shrink: true }}
            error={!!transactionIdError}
            className="text-field"
            InputProps={{ readOnly: "true" }}
          />
        </Stack>
        <Stack spacing={1} direction="column">
          <Stack spacing={1} direction="row">
            <TextField
              id="outlined-basic"
              disabled
              value={refundBalance}
              onChange={(event) => {
                setRefundBalance(event.target.value);
              }}
              size="small"
              label="Refund Balance"
              variant="outlined"
              className="text-field"
              InputLabelProps={{ shrink: true }}
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={includeRefundBalance}
                  onChange={handleCheckboxChange}
                />
              }
              label="Include"
            />
          </Stack>

          <TextField
            id="outlined-basic"
            value={description}
            onChange={(event) => {
              setDescription(event.target.value);
            }}
            multiline
            className="description-field"
            rows={2}
            inputProps={{ maxLength: 250 }}
            label="Description"
            variant="outlined"
          />

          <Button
            className="save_update_btn"
            variant="contained"
            disabled={isLoading}
            onClick={() => {
              if (annualSubscriptionPaymentId) {
                let totalAmountPaidError = "";
                let dateofbirthError = "";
                let paymentModeError = "";
                let amountPayableError = "";
                let transactionIdError = "";
                let addonTypeError = "";

                if (
                  !totalAmountPayable ||
                  parseFloat(totalAmountPayable) === 0
                ) {
                  amountPayableError = "Amount Payable is required";
                } else if (
                  !totalAmountPayable ||
                  parseFloat(totalAmountPayable) < 0
                ) {
                  amountPayableError = "Amount Payable can't negative";
                }

                // Validate Addon Type
                if (
                  !addonTypeName ||
                  addonTypeName === "" ||
                  parseFloat(addonTypeName) === 0
                ) {
                  addonTypeError = "Addon Type is required";
                }

                // Validate amount paid

                if (!includeRefundBalance) {
                  if (!totalAmountPaid || parseFloat(totalAmountPaid) === "") {
                    totalAmountPaidError = "Amount Paid is required";
                  } else if (
                    !totalAmountPaid ||
                    parseFloat(totalAmountPaid) < 0
                  ) {
                    totalAmountPaidError = "Amount Paid is can't negative";
                  } else if (
                    concession &&
                    parseFloat(totalAmountPaid) >
                      parseFloat(addonType) - parseFloat(concession)
                  ) {
                    totalAmountPaidError =
                      "Amount Paid can't greater than the amount after concession";
                  } else if (
                    !concession &&
                    parseFloat(totalAmountPaid) > parseFloat(addonType)
                  ) {
                    totalAmountPaidError =
                      "Amount Paid can't greater than the annual subscription payment";
                  }
                }
                else if(includeRefundBalance){
                  if ((!totalAmountPaid || totalAmountPaid === "" || isNaN(parseFloat(totalAmountPaid))) && amountPending !== 0) {
                    totalAmountPaidError = "Amount Paid is required";
                  }else if (parseFloat(totalAmountPaid) < 0) {
                    totalAmountPaidError = "Amount Paid cannot be negative";
                  } else if (
                    amountPayableAfterConcession &&
                    parseFloat(totalAmountPaid) > amountPayableAfterConcession
                  ) {
                    totalAmountPaidError =
                      "Amount can't exceed amount after concession";
                  } else if (
                    !concession &&
                    parseFloat(totalAmountPaid) > parseFloat(addonType)
                  ) {
                    totalAmountPaidError =
                      "Amount can't exceed annual subscription payment";
                  }
                
                }
                else if(includeRefundBalance){
                  if ((!totalAmountPaid || totalAmountPaid === "" || isNaN(parseFloat(totalAmountPaid))) && amountPending !== 0) {
                    totalAmountPaidError = "Amount Paid is required";
                  }else if (parseFloat(totalAmountPaid) < 0) {
                    totalAmountPaidError = "Amount Paid cannot be negative";
                  } else if (
                    amountPayableAfterConcession &&
                    parseFloat(totalAmountPaid) > amountPayableAfterConcession
                  ) {
                    totalAmountPaidError =
                      "Amount can't exceed amount after concession";
                  } else if (
                    !concession &&
                    parseFloat(totalAmountPaid) > parseFloat(addonType)
                  ) {
                    totalAmountPaidError =
                      "Amount can't exceed annual subscription payment";
                  }
                
                }

                if (
                  (paymentModeName === "UPI" ||
                    paymentModeName === "DD/Cheque") &&
                  (!utrId || utrId.trim() === "")
                ) {
                  transactionIdError =
                    paymentModeName === "DD/Cheque"
                      ? "DD/Cheque number is required."
                      : "Transaction ID is required.";
                }

                // Validate payment date
                if (!paymentDate) {
                  dateofbirthError = "Payment date is required";
                }

                // Validate payment mode
                if (
                  !paymentModeName ||
                  paymentModeName === "" ||
                  parseFloat(paymentModeName) === 0
                ) {
                  paymentModeError = "Payment Mode is required";
                }
                console.log("payment mode:", paymentModeName);

                // Set errors and stop form submission if there are any errors
                if (
                  totalAmountPaidError ||
                  dateofbirthError ||
                  paymentModeError ||
                  amountPayableError ||
                  transactionIdError ||
                  addonTypeError
                ) {
                  setTotalAmountPaidError(totalAmountPaidError);
                  setDateofbirthError(dateofbirthError);
                  setPaymentModeError(paymentModeError);
                  setAmountPayableError(amountPayableError);
                  setTransactionIdError(transactionIdError);
                  setAddonTypeError(addonTypeError);
                  return;
                }

                // Clear errors if no issues
                setTotalAmountPaidError("");
                setConcessionError("");
                setDateofbirthError("");
                setPaymentModeError("");
                setAmountPayableError("");
                setTransactionIdError("");
                setAddonTypeError("");

                const otpRequired = isOtpEnabled('AnnualSubscription');
                if (otpRequired) {
                  handleGetOtp();
                } else {
                  editPaymentDetails();
                }
              } else {
                addPaymentDetails();
              }
            }}
            style={{ alignSelf: "flex-end" }}
            backgroundColor="#0A64A2"
          >
            {isLoading ? "Saving..." :annualSubscriptionPaymentId ? "Update" : "Save"}
          </Button>
        </Stack>
      </Stack>
      <br />
      <div className="main_title">Annual Subscription of {studentName}</div>

      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 700 }}
          aria-label="customized table"
          size="medium"
        >
          <TableHead>
            <TableRow className="table-header">
              <TableCell
                sortDirection={
                  orderBy === "annual_subscription_payment_id" ? order : false
                }
                align="center"
              >
                <TableSortLabel
                  active={orderBy === "annual_subscription_payment_id"}
                  direction={
                    orderBy === "annual_subscription_payment_id"
                      ? order
                      : "desc"
                  }
                  onClick={(event) =>
                    handleRequestSort(event, "annual_subscription_payment_id")
                  }
                  className="table-sort-label"
                >
                  Annual Subscription ID
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "addon_type_name" ? order : false}
              >
                <TableSortLabel
                  active={orderBy === "addon_type_name"}
                  direction={orderBy === "addon_type_name" ? order : "asc"}
                  onClick={(event) =>
                    handleRequestSort(event, "addon_type_name")
                  }
                  className="table-sort-label-addontype"
                >
                  Add-on Type
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "amount_paid" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "amount_paid"}
                  direction={orderBy === "amount_paid" ? order : "asc"}
                  onClick={(event) => handleRequestSort(event, "amount_paid")}
                  className="table-sort-label"
                >
                  Amount Paid
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "refund_amount_used" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "refund_amount_used"}
                  direction={orderBy === "refund_amount_used" ? order : "asc"}
                  onClick={(event) =>
                    handleRequestSort(event, "refund_amount_used")
                  }
                  className="table-sort-label"
                >
                  Refund Used
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "amount_pending" ? order : false}
                className="table-cell"
              >
                <TableSortLabel
                  active={orderBy === "amount_pending"}
                  direction={orderBy === "amount_pending" ? order : "asc"}
                  onClick={(event) =>
                    handleRequestSort(event, "amount_pending")
                  }
                  className="table-sort-label"
                >
                  Amount Pending
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "payment_date" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "payment_date"}
                  direction={orderBy === "payment_date" ? order : "asc"}
                  onClick={(event) => handleRequestSort(event, "payment_date")}
                  className="table-sort-label"
                >
                  Date
                </TableSortLabel>
              </TableCell>
              <TableCell
                align="center"
                sortDirection={orderBy === "payment_mode_name" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "payment_mode_name"}
                  direction={orderBy === "payment_mode_name" ? order : "asc"}
                  onClick={(event) =>
                    handleRequestSort(event, "payment_mode_name")
                  }
                  className="table-sort-label"
                >
                  Payment Mode
                </TableSortLabel>
              </TableCell>

              <TableCell
                align="center"
                sortDirection={orderBy === "description" ? order : false}
                className="table-sort-label"
              >
                <TableSortLabel
                  active={orderBy === "description"}
                  direction={orderBy === "description" ? order : "asc"}
                  onClick={(event) => handleRequestSort(event, "description")}
                  className="table-sort-label-desc"
                >
                  Description
                </TableSortLabel>
              </TableCell>
              <TableCell align="center" className="table-sort-label-recipt">
                Receipt
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedRows.map((row) => (
              <TableRow
                key={row.annual_subscription_payment_id}
                onClick={() =>
                  handleSelectRow(
                    row.annual_subscription_payment_id,
                    row.addon_type_name,
                    row.amount_payable,
                    row.concession,
                    row.amount_paid,
                    row.amount_pending,
                    row.payment_date,
                    row.payment_mode_name,
                    row.refund_amount,
                    row.refund_amount_used,
                    row.transaction_id,
                    row.description,
                    row.payment_mode_id
                  )
                }
                style={{ cursor: "pointer" }}
              >
                <TableCell component="th" scope="row" align="center">
                  {row.annual_subscription_payment_id}
                </TableCell>
                <TableCell align="center">{row.addon_type_name}</TableCell>
                <TableCell align="center">{row.amount_paid}</TableCell>
                <TableCell align="center">{row.refund_amount_used}</TableCell>
                <TableCell align="center">{row.amount_pending}</TableCell>
                <TableCell align="center">{row.payment_date}</TableCell>
                <TableCell align="center">
                  {row.payment_mode_name}{" "}
                  {row.transaction_id && (
                    <>
                      <br />({row.transaction_id})
                    </>
                  )}
                </TableCell>

                <TableCell align="center">{row.description}</TableCell>
                <TableCell align="center">
                  {" "}
                  <Button
                    variant="text"
                    onClick={(event) => handleDownload(row, event)}
                    startIcon={<DownloadIcon />}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow className="table-header">
              <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                count={annualSubscription.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                className="table-pagination"
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>

      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          setShowSnackbarMessage(false);
        }}
        message={snackbarMessage}
      >
        <Alert
          severity={snackbarMessageColor}
          variant="filled"
          className="alert"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Modal open={isOtpModalOpen} onClose={handleCloseModal}>
        <Box className="modalStyle">
          {/* Close Button in the top-right corner */}
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            style={{ position: "absolute", top: 7, right: 10 }}
          >
            <CloseIcon />
          </IconButton>

          <h3 className="enter-otp">Enter OTP</h3>
          <Divider className="divider" />
          {verifyOTPMsg && <p className="invalid-otp">{verifyOTPMsg}</p>}

          {/* OTP Input Boxes */}
          <div className="otp-container">
            {otp.map((data, index) => (
              <TextField
                autoFocus={index === 0}
                key={index}
                value={data}
                onChange={(e) => handleOtpChange(e, index)}
                inputProps={{
                  maxLength: 1,
                  id: `otp-input-${index}`, // Set id for focus management
                  style: {
                    textAlign: "center", // Center the text inside
                    fontSize: "17px", // Font size adjustment
                    width: "40px", // Set width and height equal to make it square
                    height: "40px", // Set width and height equal to make it square
                    padding: 0, // Remove default padding
                    boxSizing: "border-box", // Ensure borders don't affect the box size
                  },
                }}
                InputProps={{
                  style: {
                    textAlign: "center",
                  },
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    padding: 0, // Remove extra padding to keep it square
                  },
                }}
              />
            ))}
          </div>

          {/* Verify and Resend OTP Message */}
          <div className="otp-btn-container">
            {/* Resend OTP Control */}
          {canResend ? (
  <p
    className="resend-otp"
    style={{ color: "green", cursor: "pointer" }}
    onClick={handleResendOtp}
  >
    Resend OTP {resendCount}/3
  </p>
) : (
  <p style={{ color: "red" }}>
    Resend OTP in {formatTime(resendTimer)}
  </p>
)}


            <Button
              variant="contained"
              onClick={handleVerifyOtp} // Use handleVerifyOtp for verification
              className="verify-btn"
            >
              Verify
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

